import React from 'react';
import MuiButton from '@mui/material/Button';
import { withStyles } from '@mui/styles';

const styles = theme => {
  return (
    {
      root: {
        color: '#2C2C2C !important',
        fontSize: '16px !important',
        padding: '0.3rem 0.3rem !important',
        background: '#F2F0F3 !important',
        backgroundColor: '#F2F0F3 !important',
        borderRadius: '5px !important',
        fontWeight: 500,
        textTransform: 'none !important',
        letterSpacing: '0 !important',
        border: 'none',
        '&:hover': {
          background: '#d5d5d5 !important',
          backgroundColor: '##d5d5d5 !important',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1)',
          transform: 'translateY(-1px)',
        },
      }
    }
  )
}

const ViewFiltersButton = withStyles(styles)(({ classes, ...props }) => (
  <MuiButton
    variant="contained"
    className={classes.root}>
    View & Filters
  </MuiButton>
));

export default ViewFiltersButton;